<template lang="pug">
global-form-group(
    :title="field.title"
    :field-name="field.name"
    :edit-toggle="true"
    @toggle_edit='toggle_edit'
    v-if="!isMobile")
	div.slotInput(:class="editable ? '' : 'disable-edit'")
		a-time-picker(
			style="width: 100%"
			v-model:value="timePickerDefault"
			@change="changePicker"
			:allowClear="true"
			format="HH:mm"

			v-model:open="openPopup"

		)
			template(#addon)
				a-button(
					size="small"
					type="primary"
					@click="openPopup=!openPopup"
				) Done

		div.desc.mt-2 {{ field.description }}

div(v-else)
	time-mobile(
		:field="field"
		:selected="selected"
        @toggle_edit="toggle_edit"
		@select="select"
	)
</template>

<script>
	import GlobalFormGroup from "../../GlobalFormGroup";
	import moment, { Moment } from 'moment';
	import TimeMobile from "@/components/settings_element/time/TimeMobile";

	export default  {
		name: "Time",
		components: {TimeMobile, GlobalFormGroup},
		props: {
			field: {

			},

			selected: {
				type: Object,
				default() {
					return {
						value: {
							m: 0,
							h: 12
						}
					}
				}
			}
		},

		data() {
			return {
				h_tmp: 0,
				m_tmp: 0,
				openPopup: false,
				timePickerDefault: '',
                enable_edit: true
			}
		},

		mounted() {
			this.h_tmp = this.selected.value ? this.selected.value.hours: '';
			this.m_tmp = this.selected.value ? this.selected.value.minutes: '';

			this.timePickerDefault = moment(`${this.h_tmp}:${this.m_tmp}:0`, 'H:m:s')
		},

		computed: {
			isMobile() {
				return nse_app.isMobile;
			},
            editable() {
                return this.store.value[`editable_${this.field.name}`];
            }
		},
		methods: {
            toggle_edit() {
                var o = Object.assign({}, this.field, {
                    value: {
                        hours : this.timePickerDefault.format("H"),
                        minutes : this.timePickerDefault.format("m"),
                    }
                });
                this.$emit('select', o);
            },

			select(o) {
				this.$emit('select', o);
			},

			changePicker(value){
				var o = Object.assign({}, this.field, {
					value: {
						hours : value.format("H"),
						minutes : value.format("m"),
					}
				});
				this.$emit('select', o);
			}
		},
	}
</script>


<style lang="scss">
	.time-select {
		display: flex;
		justify-content: space-between;
		align-items: center;
		align-content: center;
		select {
			background-color: transparent;
			border: none;
			border-bottom: 1px solid black;
			padding: 5px 2px;
			width: 40%;
			+ select {
				margin-left: 10%;
			}
		}
	}
</style>
